import { createContext } from 'react'

export type InfoArgs = {
  title?: string
  content: string | React.ReactElement
  okButton?: string
  variant?: 'default' | 'error' | 'success'
}

export type InfoDialogContextType = {
  showInfo: (args: InfoArgs) => void
  closeInfo: () => void
}

export const InfoDialogContext = createContext<InfoDialogContextType>({
  showInfo: () => {},
  closeInfo: () => {
    // do nothing
  }
})
